import * as React from 'react'
import Styles from './View.module.css'

export const View = ({ children }: { children: React.ReactNode }): React.ReactElement => {
	return <div className={Styles.container}>{children}</div>
}
